import { AxiosRequestConfig } from "axios";
import api from "../../apiClient";
import {
  AgentAssignment,
  CreateAgentAssignmentRequest,
  UpdateAgentAssignmentRequest,
  AgentAssignmentListParams,
  AgentAssignmentListResponse,
  PlayerFacility,
  CreatePlayerFacilityRequest,
  PlayerFacilityListParams,
  PlayerFacilityListResponse,
} from "./types";

class AgentAssignmentService {
  // Agent Assignment Methods
  async createAssignment(
    data: CreateAgentAssignmentRequest,
    config?: AxiosRequestConfig,
  ): Promise<AgentAssignment> {
    const response = await api.post("/agent-assignments", data, config);
    return response.data;
  }

  async getAssignment(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<AgentAssignment> {
    const response = await api.get(`/agent-assignments/${id}`, config);
    return response.data;
  }

  async listAssignments(
    params?: AgentAssignmentListParams,
    config?: AxiosRequestConfig,
  ): Promise<AgentAssignmentListResponse> {
    const response = await api.get("/agent-assignments", {
      ...config,
      params,
    });
    return response.data;
  }

  async updateAssignment(
    id: string,
    data: UpdateAgentAssignmentRequest,
    config?: AxiosRequestConfig,
  ): Promise<AgentAssignment> {
    const response = await api.put(`/agent-assignments/${id}`, data, config);
    return response.data;
  }

  async deactivateAssignment(
    id: string,
    config?: AxiosRequestConfig,
  ): Promise<AgentAssignment> {
    const response = await api.delete(`/agent-assignments/${id}`, config);
    return response.data;
  }

  // Player Facility Methods
  async addFacility(
    data: CreatePlayerFacilityRequest,
    config?: AxiosRequestConfig,
  ): Promise<PlayerFacility> {
    const response = await api.post(
      "/agent-assignments/facilities",
      data,
      config,
    );
    return response.data;
  }

  async listFacilities(
    params?: PlayerFacilityListParams,
    config?: AxiosRequestConfig,
  ): Promise<PlayerFacilityListResponse> {
    const response = await api.get("/agent-assignments/facilities", {
      ...config,
      params,
    });
    return response.data;
  }

  async approveFacility(
    facilityId: string,
    config?: AxiosRequestConfig,
  ): Promise<PlayerFacility> {
    const response = await api.post(
      `/agent-assignments/facilities/${facilityId}/approve`,
      {},
      config,
    );
    return response.data;
  }
}

export const agentAssignmentService = new AgentAssignmentService();
